export default "__VITE_ASSET__cf7d96fd__"